/**
 * Mock invoice dataset used by the Invoices tab in demo mode. Amounts are gross;
 * the Net / VAT split is derived so demo mode mirrors live invoices.
 *
 * Shared so that any consumer of the demo "Invoiced" total (billing summary bar,
 * Overview Sales Performance card) reads from the same dataset.
 */
import { splitGrossIntoNetAndVat } from "@/lib/billing-summary";

export const DEMO_INVOICES = [
  {
    id: 1,
    invoiceNumber: "INV-2024-001" as string | null,
    date: "2024-01-15" as string | null,
    description: "Monthly Development Services - January",
    amount: 12500,
    created: "2024-01-10" as string | null,
    due: "2024-02-15" as string | null,
    status: "Paid" as const,
  },
  {
    id: 2,
    invoiceNumber: "INV-2024-002" as string | null,
    date: "2024-02-15" as string | null,
    description: "Monthly Development Services - February",
    amount: 15000,
    created: "2024-02-10" as string | null,
    due: "2024-03-15" as string | null,
    status: "Paid" as const,
  },
  {
    id: 3,
    invoiceNumber: "INV-2024-003" as string | null,
    date: "2024-03-15" as string | null,
    description: "Monthly Development Services - March",
    amount: 13750,
    created: "2024-03-10" as string | null,
    due: "2024-04-15" as string | null,
    status: "Overdue" as const,
  },
  {
    id: 4,
    invoiceNumber: "INV-2024-004" as string | null,
    date: "2024-04-15" as string | null,
    description: "Monthly Development Services - April",
    amount: 14200,
    created: "2024-04-10" as string | null,
    due: "2024-05-15" as string | null,
    status: "Sent" as const,
  },
  {
    id: 5,
    invoiceNumber: "DRAFT-005" as string | null,
    date: null as string | null,
    description: "Monthly Development Services - May",
    amount: 8500,
    created: "2024-05-01" as string | null,
    due: null as string | null,
    status: "Draft" as const,
  },
  {
    id: 6,
    invoiceNumber: null as string | null,
    date: null as string | null,
    description: "Additional Features Development",
    amount: 5200,
    created: null as string | null,
    due: null as string | null,
    status: "Draft" as const,
  },
].map((inv) => ({ ...inv, ...splitGrossIntoNetAndVat(inv.amount) }));
